import React from 'react';
import { useTranslation } from 'react-i18next';
import AIChat from '../components/ai/AIChat';

const AIChatPage = () => {
    const { t } = useTranslation();
    return (
        <div className="h-full">
            <AIChat />
        </div>
    );
};

export default AIChatPage;
